/* This file exists to prevent a circular dependency between assignment-types and catalog.utilities.
    The function in this file could have been moved into
    assignment-types.shared.utilities.ts, but it depends on many other modules, and moving all of
    them would require a large refactor. To avoid that, the function is defined here so it can be
    consumed from the assignment-types folder without introducing a circular dependency.
*/
import { RecContentItemDto } from '../../apis/rec-gateway/rec-gateway.dtos';
import { CatalogWithExternalEntitiesDto, OsmosisTokenDto } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { SherpathLessonOsmosisIncludesConfigs } from '../osmosis-video-editor/osmosis-video.constants';
import { getSherpathLessonOsmosisIncludesConfigs } from './catalog.utilities';

export const getOsmosisTokenAndConfigPromise = (props: {
  isOsmosisVideosEnabled: boolean;
  catalog: CatalogWithExternalEntitiesDto;
  contentItem: RecContentItemDto;
  fetchOsmosisTokenAction: Function;
}): Promise<{
  osmosisToken: OsmosisTokenDto;
  osmosisIncludesConfigs: SherpathLessonOsmosisIncludesConfigs;
}> => {

  const {
    isOsmosisVideosEnabled,
    catalog,
    contentItem,
    fetchOsmosisTokenAction
  } = props;

  if (!isOsmosisVideosEnabled) {
    return Promise.resolve(null);
  }

  const osmosisIncludesConfigs = getSherpathLessonOsmosisIncludesConfigs(contentItem, catalog, isOsmosisVideosEnabled);
  const hasOsmosisVideo = osmosisIncludesConfigs?.length;

  if (!hasOsmosisVideo) {
    Promise.resolve(null);
  }
  return fetchOsmosisTokenAction().then((osmosisToken) => {
    return {
      osmosisToken,
      osmosisIncludesConfigs
    };
  });
};
